import { put, call, takeEvery } from "redux-saga/effects";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

import * as apis from "../../network/apis/applicantReport";
import * as types from "./types";
import * as actions from "./actions";

function* getApplicantReportsListSaga({ payload }) {
  try {
    yield put(
      actions.getApplicantReportsResponse({
        list: [],
        meta: {},
      })
    );
    const response = yield call(apis.getApplicantReportList, payload);
    yield put(
      actions.getApplicantReportsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getApplicantReportsRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* uploadApplicantReport({ payload }) {
  let apiPayload = {
    data: payload?.request_body,
    event_id: payload?.id,
  };
  try {
    const response = yield call(apis.postApplicantReports, apiPayload);
    yield put(actions.uploadApplicantReportsResponse(response.data));
    yield showSuccessMsg(response?.message, response.success);
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An error occurred";
    yield showErrorMsg(errorMessage);
  }
}
function* deleteApplicantReport({ payload }) {
  try {
    const response = yield call(apis.deleteApplicantReport, payload);
    yield put(actions.deleteApplicantReportsResponse(response.data));
    yield showSuccessMsg(response?.message, response.success);
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An error occurred";
    yield showErrorMsg(errorMessage);
  }
}

function* exportApplicantReportSheetListSaga({ payload }) {
  let payloadObj = {
    event_id: payload?.eventId,
    id: payload?.fileId,
  };

  try {
    const response = yield call(apis.exportApplicantSheet, payloadObj);
    const fileData = response.data?.data;
    if (!fileData || !fileData.upload_url) {
      throw new Error("File URL not found in response");
    }

    const fileResponse = yield call(fetch, fileData.upload_url);
    const blob = yield call([fileResponse, "blob"]);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = payload?.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put(showSuccessMsg("File downloaded successfully!", true));
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* exportApplicantReportSheetListSagaAll({ payload }) {
  let payloadObj = {
    event_id: payload?.eventId,
  };
  try {
    const response = yield call(apis.exportAllApplicantReportFiles, payloadObj);
    if (response.data.data && Array.isArray(response.data.data.files)) {
      for (let file of response.data.data.files) {
        const fileResponse = yield call(fetch, file?.upload_url);
        const blob = yield call([fileResponse, "blob"]);

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file?.file_name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }

      yield put(showSuccessMsg("All files downloaded successfully!", true));
    } else {
      throw new Error("No files found to download");
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

export default function* ApplicantReportSagas() {
  yield takeEvery(
    types.GET_APPLICANT_REPORTS_REQUEST,
    getApplicantReportsListSaga
  );
  yield takeEvery(
    types.EXPORT_APPLICANT_REPORT_SHEET_REQUEST,
    exportApplicantReportSheetListSaga
  );
  yield takeEvery(
    types.EXPORT_APPLICANT_REPORT_SHEET_REQUEST_ALL,
    exportApplicantReportSheetListSagaAll
  );
  yield takeEvery(
    types.UPLOAD_APPLICANT_REPORTS_REQUEST,
    uploadApplicantReport
  );
  yield takeEvery(
    types.DELETE_APPLICANT_REPORTS_REQUEST,
    deleteApplicantReport
  );
}
